import type { MaskTokens } from '../types'
import type maskitFunc from './maskit'

export default function dynamicMask(
  maskit: typeof maskitFunc,
  masks: Array<string>,
  tokens: MaskTokens,
) {
  masks = masks.sort((a, b) => a.length - b.length)

  return function(value: string, mask: Array<string> | string, masked = true, caretPosition: number) {
    let i = 0

    while (i < masks.length) {
      const currentMask = masks[i]
      i++
      const nextMask = masks[i]

      if (!(nextMask && maskit(value, nextMask, true, tokens, caretPosition).value.length > currentMask.length)) {
        return maskit(value, currentMask, masked, tokens, caretPosition)
      }
    }

    return { value: '', caretPosition } // empty masks
  }
}
